export const routes = {
	fetchAllDynamicProperties: "/DynamicProperties/v1.0/all",
	looks: "/Looks/v1.0",
	layouts: "/Layouts/v1.0",
	sizes: "/Sizes/v1.0",
	customers: "/Customers/v1.0",
	renders: "/Renders/v1.0",
};
